import { useEffect, useRef, useState, useMemo } from "react";
import { saveAs } from "file-saver";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconFilter from "../../component/SvgIcons/IconFilter";
import IconSearchTable from "../../component/SvgIcons/IconSearchTable";
import api from "../../services/axios";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import { AnimatePresence, motion } from "framer-motion";
import CustomDropdown from "../../component/CustomDropdown";
import numberOptions from "../../component/NumberOptions/numberOptionsdata";
import { useSwal } from "../../services/SweetAlert";
import ExcelJS from "exceljs";
import { useAuth } from "../../context/AuthContext";
import DateFilter from "../../component/DateFilter/DateFilter";
import ExcelDownload from "../../component/SvgIcons/ExcelDownload";
import { useNavigate } from "react-router-dom";
export default function EscalatedReport() {
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [appType, setAppType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(
    window.innerWidth >= 1920 ? 16 : 10
  );
  const { authUser } = useAuth();
  const [isCustomDateFilter, setIsCustomDateFilter] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const { alert } = useSwal();
  const navigate = useNavigate();
  const [visibleColumns, setVisibleColumns] = useState([
    "Ticket_No",
    "Contact_Person",
    "Issue_Details",
    "escalated_Status",
    "Contact_Email_Id",
    "Contact_Mobile_No",
    "Application_Name",
    "Customer_Type",
    "escalated_to",
    "Create_Date_Time_Stamp",
  ]);

  const tableRef = useRef(null);
  const selectAllRef = useRef();

  const normalizeStartDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const normalizeEndDate = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  const handlePeriodSelect = (periodLabel, startDate, endDate) => {
    if (startDate && endDate) {
      const sDate = normalizeStartDate(startDate);
      const eDate = normalizeEndDate(endDate);

      const filtered = rowData.filter((ticket) => {
        const createdDate = new Date(ticket.Create_Date_Time_Stamp);
        return createdDate >= sDate && createdDate <= eDate;
      });
      setFilteredTickets(filtered);
      setCurrentPage(1);
      setIsCustomDateFilter(true);
    } else {
      setFilteredTickets([]);
      setIsCustomDateFilter(false);
    }
  };

  // Fetch customer data
  useEffect(() => {
    const fetchCustomers = async () => {
      setLoading(true);
      try {
        const payload = {};
        // const payload = authUser.isAdmin
        //   ? { isAdmin: true }
        //   : {
        //     isAdmin: false,
        //     Code: authUser.Code,
        //     Agents_Company: authUser.Agents_Company,
        //   };

        payload['url'] = window.location.search?.split('?')[1];
        if(!payload['url']){
          payload['url'] = "day=&filterName=3"
        }
        payload['isEscalated'] = 1;
        const res = await api.post("/filterTicketSearch", payload);
        // const res = await api.post("/list_ticket", payload);
        // console.log("Fetched tickets:", res.data.data);

        const tickets = Array.isArray(res.data.data) ? res.data.data : [];
        // Filter only escalated tickets
        // const escalated = tickets.filter(
        //   (ticket) => ticket.Status_Name === "Escalated"
        // );

        setRowData(tickets);
        if (tickets.length === 0) {
          console.warn("No escalated tickets found.");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchCustomers();
  }, [authUser]); // or [] if authUser never changes

  useEffect(() => {
    if (!selectAllRef.current) return;

    const pageRowIds = paginatedData.map((row) => row.Code); // <-- here 'row.Code'?
    const selectedCount = pageRowIds.filter((id) =>
      selectedRows.includes(id)
    ).length;

    selectAllRef.current.indeterminate =
      selectedCount > 0 && selectedCount < pageRowIds.length;
  }, [selectedRows, rowData, currentPage]);

  const dataToFilter = isCustomDateFilter ? filteredTickets : rowData;
  // Filter and sort data
  const filteredData = useMemo(() => {
    let result = dataToFilter
      .filter((row) => {
        const matchesSearch = visibleColumns.some((column) =>
          row[column]
            ?.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );
        return matchesSearch;
      })
      .sort((a, b) => {
        if (!sortConfig.key) return 0;

        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (aValue === undefined || bValue === undefined) return 0;

        const isNumber = !isNaN(aValue) && !isNaN(bValue);
        if (isNumber) {
          return sortConfig.direction === "asc"
            ? Number(aValue) - Number(bValue)
            : Number(bValue) - Number(aValue);
        } else {
          return sortConfig.direction === "asc"
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
        }
      });

    // Deduplicate by Ticket_No, keep latest Create_Date_Time_Stamp
    const ticketMap = new Map();
    result.forEach((row) => {
      const ticketNo = row.Ticket_No;
      const currentDate = new Date(row.Create_Date_Time_Stamp);

      if (!ticketMap.has(ticketNo)) {
        ticketMap.set(ticketNo, row);
      } else {
        const existingRow = ticketMap.get(ticketNo);
        const existingDate = new Date(existingRow.Create_Date_Time_Stamp);
        if (currentDate > existingDate) {
          ticketMap.set(ticketNo, row);
        }
      }
    });

    return Array.from(ticketMap.values());
  }, [dataToFilter, visibleColumns, searchQuery, sortConfig]);

  // Pagination
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, currentPage]);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  useBootstrapTooltip([paginatedData, currentPage]);
  const handlePageChange = (page) => setCurrentPage(page);

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };
  const handleSelectAll = () => {
    const pageRowIds = paginatedData.map((row) => row.Ticket_No);
    const allSelected = pageRowIds.every((id) => selectedRows.includes(id));
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((id) => !pageRowIds.includes(id)));
    } else {
      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIds])]);
    }
  };

  const handleSort = (field) => {
    setSortConfig((prev) => {
      if (prev.key === field) {
        // toggle direction
        return {
          key: field,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }
      // new sort field, default to ascending
      return { key: field, direction: "asc" };
    });
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    setFilteredTickets([]);
  };

  const columnMap = {
    Ticket_No: "Ticket_No",
    Contact_Person: "Contact_Person",
    Issue_Details: "Issue_Details",
    Status_DisplayName: "escalated_Status",
    Contact_Email_Id: "Contact_Email_Id",
    Contact_Mobile_No: "Contact_Mobile_No",
    Customer_Type: "Customer_Type",
    Create_Date_Time_Stamp: "Create_Date_Time_Stamp",
  };

  const columnHeaders = {
    Ticket_No: "Ticket No",
    Contact_Person: "Customer Name",
    Issue_Details: "Issue Details",
    escalated_Status: "Status",
    Contact_Email_Id: "Email",
    Contact_Mobile_No: "Mobile Number",
    Customer_Type: "Customer Type",
    Create_Date_Time_Stamp: "Date",
  };

  const getExportData = () => {
    return filteredData.map((row) => {
      const exportRow = {};
      visibleColumns.forEach((col) => {
        let value = row[columnMap[col]] ?? "";

        // Format date if the column is Create_Date_Time_Stamp
        if (
          col === "Create_Date_Time_Stamp" &&
          value &&
          value !== "0000-00-00 00:00:00"
        ) {
          const date = new Date(value);
          if (!isNaN(date)) {
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            value = `${day}-${month}-${year}`;
          } else {
            value = "";
          }
        }

        // Remove 'htnkl' from Issue Details
        // Clean up Issue Details: remove HTML tags and 'htnkl'
        if (col === "Issue_Details") {
          // Remove HTML tags
          value = value.replace(/<[^>]*>/g, "").trim();

          // Remove value if it's exactly "htnkl" after stripping HTML
          if (value === "htnkl") {
            value = "";
          }
        }

        exportRow[columnHeaders[col]] = value;
      });
      return exportRow;
    });
  };

  const handleExcelDownload = async () => {
    const dataToExport = getExportData();
    if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
      await alert("warning", "No data available to export.");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Escalated Ticket Report");

    const headers = Object.keys(dataToExport[0]);

    // 1️⃣ Add merged title row at the top (row 1)
    worksheet.mergeCells(1, 1, 1, headers.length); // Merge from A1 to last column in row 1
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Escalated Ticket Report";
    titleCell.font = {
      name: "Arial",
      size: 14,
      bold: true,
      color: { argb: "FFFFFF" },
    };
    titleCell.alignment = { vertical: "middle", horizontal: "center" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF0000" }, // Red background
    };
    worksheet.getRow(1).height = 25;

    // 2️⃣ Add header row in row 2
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "000000" }, // Red
      };
      cell.font = {
        color: { argb: "FFFFFF" },
        bold: true,
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      };
    });

    // 3️⃣ Add data rows starting from row 3
    dataToExport.forEach((row) => {
      const rowValues = headers.map((header) => row[header]);
      worksheet.addRow(rowValues);
    });

    // 4️⃣ Set column widths and style data rows
    worksheet.columns.forEach((column) => {
      column.width = 20;
    });

    worksheet.eachRow({ includeEmpty: false }, function (row, rowNumber) {
      // Skip styling the title (row 1) and headers (row 2) as they are already styled
      if (rowNumber > 2) {
        row.eachCell((cell) => {
          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin", color: { argb: "000000" } },
            bottom: { style: "thin", color: { argb: "000000" } },
            left: { style: "thin", color: { argb: "000000" } },
            right: { style: "thin", color: { argb: "000000" } },
          };
        });
      }
    });

    // 5️⃣ Export file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "EscalatedTicketReport.xlsx");
  };

  return (
    <div className="escalation-report">
      <Header title subtitle="Escalations Details" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <AnimatePresence mode="wait">
              <motion.div
                className="pagegap d-flex flex-column"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }}
              >
                <h2 className="create-titles mb-0 d-flex align-items-center">
                  <DiamondsFour /> <span>Escalations Details</span>
                </h2>
                <div className="tabletopbar d-flex align-items-center gap-2 justify-content-between flex-column flex-md-row">
                  <div className="tablefilter d-flex align-items-center">
                    <DateFilter onPeriodSelect={handlePeriodSelect} />

                    <div
                      className={`selacteditems d-flex align-items-center ${selectedRows.length > 0 ? "selectedvalue" : ""
                        }`}
                    >
                      <span>{selectedRows.length} Selected</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    <button
                      type="button"
                      onClick={handleExcelDownload}
                      className="tranparenteffect position-relative excellsheet"
                    >
                      <ExcelDownload />
                    </button>
                    <div className="tablesearch position-relative">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                      <span className="position-absolute">
                        <IconSearchTable />
                      </span>
                    </div>

                    <CustomDropdown
                      name="itemsPerPage"
                      options={numberOptions}
                      value={itemsPerPage.toString()}
                      onChange={(value) => {
                        const num = Number(value);
                        setItemsPerPage(num);
                        setCurrentPage(1);
                      }}
                      placeholder="Items Per Page"
                      className="items-per-page-dropdown"
                    />
                  </div>
                </div>

                <div className="tablespace">
                  <div className="table-responsive" ref={tableRef}>
                    <table className="table table-hover my-0">
                      <thead className="thead-light">
                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-1">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="selectAllCheckbox"
                                ref={selectAllRef}
                                onChange={handleSelectAll}
                                checked={
                                  paginatedData.length > 0 &&
                                  paginatedData.every((row) =>
                                    selectedRows.includes(row.Ticket_No)
                                  )
                                }
                              />

                              <label
                                className="tablecheckbox headercheckbox position-relative"
                                htmlFor="selectAllCheckbox"
                              >
                                &nbsp;
                              </label>

                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Ticket_No</span>

                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Ticket_No")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </div>
                          </th>

                          {visibleColumns.includes("Contact_Person") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Customer Name
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Contact_Person")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes("Issue_Details") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Issue Details
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Issue_Details")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {/* {visibleColumns.includes("Application_Name") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Application Name
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Application_Name")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )} */}

                          {visibleColumns.includes("escalated_Status") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Status
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleSort("escalated_Status")
                                  }
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes("escalated_to") && (
                            <th width="100">
                              <div className="d-flex align-items-center justify-content-between">
                                Escalated To
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("escalated_to")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes("Contact_Email_Id") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Contact Email Id
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Contact_Email_Id")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes("Contact_Mobile_No") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Contact Mobile No
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleSort("Contact_Mobile_No")
                                  }
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes("Customer_Type") && (
                            <th>
                              <div className="d-flex align-items-center justify-content-between">
                                Customer Type
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Customer_Type")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </th>
                          )}

                          {visibleColumns.includes(
                            "Create_Date_Time_Stamp"
                          ) && (
                              <th>
                                <div className="d-flex align-items-center justify-content-between">
                                  Date
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleSort("Create_Date_Time_Stamp")
                                    }
                                  >
                                    <IconFilter />
                                  </span>
                                </div>
                              </th>
                            )}

                          <th
                            width="1"
                            style={{ padding: 0, width: "1px" }}
                          ></th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td
                              colSpan="11"
                              className="text-center"
                              style={{ padding: "30px" }}
                            >
                              Loading, please wait...
                            </td>
                          </tr>
                        ) : paginatedData.length > 0 ? (
                          paginatedData.map((row) => (
                            <tr
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/view-ticket-history/${row.Ticket_No}`
                                )
                              }
                              key={row.Code}
                              className={
                                selectedRows.includes(row.Ticket_No)
                                  ? "selected-row"
                                  : ""
                              }
                            >
                              <td onClick={(e) => e.stopPropagation()}>
                                <figure
                                  className="d-flex align-items-center custom-control-label"
                                  style={{ cursor: "pointer" }}
                                >
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`customCheckDisabled-${row.Ticket_No}`}
                                    checked={selectedRows.includes(
                                      row.Ticket_No
                                    )}
                                    onChange={() =>
                                      handleRowSelect(row.Ticket_No)
                                    }
                                  />
                                  <label
                                    className="tablecheckbox customerstable position-relative"
                                    htmlFor={`customCheckDisabled-${row.Ticket_No}`}
                                  >
                                    {row.Ticket_No}
                                  </label>
                                </figure>
                              </td>

                              {visibleColumns.includes("Contact_Person") && (
                                <td
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={row.Contact_Person}
                                >
                                  {row.Contact_Person?.split(" ")
                                    .slice(0, 2)
                                    .join(" ") +
                                    (row.Contact_Person?.split(" ").length > 5
                                      ? "..."
                                      : "")}
                                </td>
                              )}

                              {visibleColumns.includes("Issue_Details") && (
                                <td
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={row.Issue_Details.replace(
                                    /<[^>]*>/g,
                                    ""
                                  )}
                                >
                                  {row.Issue_Details.replace(/<[^>]*>/g, "") // Remove HTML tags
                                    .split(" ")
                                    .slice(0, 7)
                                    .join(" ") +
                                    (row.Issue_Details.replace(
                                      /<[^>]*>/g,
                                      ""
                                    ).split(" ").length > 5
                                      ? "..."
                                      : "")}
                                </td>
                              )}

                              {/* {visibleColumns.includes("Application_Name") && (
                                <td>
                                  {appType.find(
                                    (item) =>
                                      item.value.toString() ===
                                      row.Application_Name?.toString()
                                  )?.label || ""}
                                </td>
                              )} */}

                              {visibleColumns.includes(
                                "escalated_Status"
                              ) && (
                                  <td>
                                    <span
                                      className={`statusbtn ${row.escalated_Status ? (row.escalated_Status?.replace(
                                        /\s+/g,
                                        ""
                                      ).toLowerCase()) : 'escalated'}`}
                                    >
                                      {row.escalated_Status || 'Escalated'}
                                    </span>
                                  </td>
                                )}
                              {visibleColumns.includes("escalated_to") && (
                                <td>
                                  <p className="colorblack mb-0">
                                    {row.escalated_to?.includes("FA") && (
                                      <img
                                        className="exgrid"
                                        src="../images/fa.svg"
                                        alt="FA"
                                      />
                                    )}
                                    {row.escalated_to?.includes("GK") && (
                                      <img
                                        className="exgrid"
                                        src="../images/gk.svg"
                                        alt="GK"
                                      />
                                    )}
                                    {row.escalated_to?.includes("Gulf") && (
                                      <img
                                        className="exgrid"
                                        src="../images/gf.svg"
                                        alt="GF"
                                      />
                                    )}
                                    {row.escalated_to?.includes(
                                      "Global Software"
                                    ) && (
                                        <img
                                          className="exgrid"
                                          src="../images/gs.svg"
                                          alt="GS"
                                        />
                                      )}
                                  </p>
                                </td>
                              )}
                              {visibleColumns.includes("Contact_Email_Id") && (
                                <td>{row.Contact_Email_Id}</td>
                              )}

                              {visibleColumns.includes("Contact_Mobile_No") && (
                                <td>{row.Contact_Mobile_No}</td>
                              )}
                              {visibleColumns.includes("Customer_Type") && (
                                <td>{row.Customer_Type}</td>
                              )}
                              {visibleColumns.includes(
                                "Create_Date_Time_Stamp"
                              ) && (
                                  <td>
                                    {row.Create_Date_Time_Stamp &&
                                      row.Create_Date_Time_Stamp !==
                                      "0000-00-00 00:00:00"
                                      ? (() => {
                                        const date = new Date(
                                          row.Create_Date_Time_Stamp
                                        );
                                        if (isNaN(date)) return "";
                                        const day = String(
                                          date.getDate()
                                        ).padStart(2, "0");
                                        const month = String(
                                          date.getMonth() + 1
                                        ).padStart(2, "0");
                                        const year = date.getFullYear();
                                        return `${day}-${month}-${year}`;
                                      })()
                                      : ""}
                                  </td>
                                )}
                              <td> </td>
                            </tr>
                          ))
                        ) : isCustomDateFilter ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data found for the selected custom date range.
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {totalPages > 1 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
